import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface DowntimeScheduleDTO {
  id?: string;
  startDateTime: string;
  endDateTime: string;
  description: string;
  emailRecipients: string[];
  isActive: boolean;
  sendNotification?: boolean;
}

export interface ActiveDowntimeDTO {
  id: string;
  startDateTime: string;
  endDateTime: string;
  description: string;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DowntimeRepositoryService {
  private apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.ApiUrl;
  }

  getAll(): Observable<DowntimeScheduleDTO[]> {
    return this.http.get<DowntimeScheduleDTO[]>(`${this.apiUrl}/Downtime/GetAll`);
  }

  getActive(): Observable<ActiveDowntimeDTO> {
    return this.http.get<ActiveDowntimeDTO>(`${this.apiUrl}/Downtime/GetActive`);
  }

  getUpcoming(): Observable<ActiveDowntimeDTO[]> {
    return this.http.get<ActiveDowntimeDTO[]>(`${this.apiUrl}/Downtime/GetUpcoming`);
  }

  create(dto: DowntimeScheduleDTO): Observable<DowntimeScheduleDTO> {
    return this.http.post<DowntimeScheduleDTO>(`${this.apiUrl}/Downtime/Create`, dto);
  }

  update(dto: DowntimeScheduleDTO): Observable<DowntimeScheduleDTO> {
    return this.http.put<DowntimeScheduleDTO>(`${this.apiUrl}/Downtime/Update`, dto);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/Downtime/Delete?id=${id}`);
  }
}
